export const getViewIcon = (icon) => {
  if (!icon) return "placeholder"

  return `${icon}-dark`
}
